export var getRatingData = function getRatingData(reactSyntheticEvent, _ref) {
  var rating = _ref.rating;
  return rating;
};